import { SET_MODE } from 'actions';
import { Mode } from 'typings';

export function setMode(mode: Mode) {
  return { mode, type: SET_MODE };
}
